import { FormFieldError } from '@forms/FormFieldError/FormFieldError';
import { Input, Select } from '@iwoca/orion';
import { FieldErrorsImpl, UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { months } from '../../../../../../helpers/months';
import messages from '../MSHForm.messages';
import { TFormValues } from '../MSHForm.types';
import styles from '../MSHModal.module.css';

const DOBFields = ({
    errors,
    register,
    disabled
}: {
    errors: FieldErrorsImpl<TFormValues>;
    register: UseFormRegister<TFormValues>;
    disabled: boolean;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.fields}>
            {(errors.day || errors.month || errors.year) && (
                <FormFieldError message={messages.validDOBRequired} />
            )}

            <label className={styles.label}>Date of birth</label>

            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('day', {
                    required: true,
                    minLength: {
                        value: 2,
                        message: 'Please enter a valid number between 01-31'
                    },
                    maxLength: {
                        value: 2,
                        message: 'Please enter a valid number between 01-31'
                    }
                })}
                minLength={2}
                maxLength={2}
                wrapperClassName={`${styles.day} ${styles.field}`}
                id={'day'}
                placeholder={intl.formatMessage(messages.dayFieldPlaceholder)}
                disabled={disabled}
            />
            <Select
                {...register('month', {
                    required: true
                })}
                wrapperClassName={`${styles.month} ${styles.field}`}
                id="month"
                placeholder={intl.formatMessage(messages.monthFieldPlaceholder)}
                data-testid="month"
                disabled={disabled}
            >
                {months.map(({ value, label }, index) => (
                    <option key={index + value} value={value}>
                        {label}
                    </option>
                ))}
            </Select>
            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('year', {
                    required: true,
                    minLength: {
                        value: 4,
                        message: 'Please enter a valid year'
                    },
                    maxLength: {
                        value: 4,
                        message: 'Please enter a valid year'
                    }
                })}
                minLength={4}
                maxLength={4}
                wrapperClassName={`${styles.year} ${styles.field}`}
                id={'year'}
                placeholder={intl.formatMessage(messages.yearFieldPlaceholder)}
                disabled={disabled}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DOBFields;
